import React, { useState } from 'react';
import { Card } from '@uhg-abyss/web/ui/Card';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Box } from '@uhg-abyss/web/ui/Box';
import { Text } from '@uhg-abyss/web/ui/Text';
import { V1Table as Table } from '@uhg-abyss/web/ui/Table';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { RadioGroup } from '@uhg-abyss/web/ui/RadioGroup';
import { FormProvider } from '@uhg-abyss/web/ui/FormProvider';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { Button } from '@uhg-abyss/web/ui/Button';
import { useSelector } from 'react-redux';
import { SelectInput } from '@uhg-abyss/web/ui/SelectInput';
import { useLazySubmitMoveProfileQuery } from '@src/store/services/profileServices';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { LoadingSpinner } from '@uhg-abyss/web/ui/LoadingSpinner';
import { useAuth } from '@src/Providers/AuthProvider';
import { decryptProfileParams, encryptProfileParams } from '@src/utils';

const MoveProfile = () => {
  const data = useSelector(
    (state: { listOfValues: { data: any } }) => state?.listOfValues.data
  );
  const [resMessage, setResMessage] = useState({});
  const [isLoading, setIsLoading] = useState();
  const router = useRouter();
  const { encryptedData: profileEncryptedData } = router.getRouteParams();
  const { version, asgnId, srchDestSysCd } = profileEncryptedData
    ? decryptProfileParams(profileEncryptedData)
    : { version: undefined, asgnId: undefined, srchDestSysCd: undefined };

  const [submitMoveProfile] = useLazySubmitMoveProfileQuery();
  const [isSubmittedClicked, setIsSubmittedClicked] = useState(false);
  const { user } = useAuth();

  const { moveConfig } = data;

  const submitterDetails = useSelector(
    (state: { listOfValues: { submitterData: any } }) =>
      state?.listOfValues.submitterData
  );

  const form = useForm();
  const cardCssStyles = {
    'abyss-card-root': {
      maxWidth: '60%',
      margin: '10px auto',
    },
  };

  const profilType = form.watch('profileType');
  const targetEnvironment = form.watch('targetEnvironment');
  const movType = form.watch('profileType');
  const [error, setError] = useState();

  const validate = () => {
    let valid = true;
    let errors: any = {};

    if (!profilType) {
      errors.profilType = 'Please Select Valid ProfileType';
      valid = false;
    }

    if (!targetEnvironment) {
      errors.targetEnvironment = ' Please Select Valid Target Environment';
      valid = false;
    }

    setError(errors);
    return valid;
  };

  const handleSubmit = async () => {
    const payload = {
      submitterAssignId: submitterDetails?.submitterAssignId || asgnId,
      submitterGroupId: +submitterDetails?.submitterGroupId,
      versionNumber: +submitterDetails.versionNumber || version,
      targetEnvironment: targetEnvironment,
      userId: user?.userId,
      moveType: movType,
    };
    if (validate()) {
      setIsLoading(true);
      const reponse = await submitMoveProfile(payload);
      setResMessage(reponse);
      setIsSubmittedClicked(true);
      setIsLoading(false);
    }
  };
  const isEmptyObject = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  };

  return (
    <FormProvider state={form}>
      <Grid>
        <Grid.Col
          css={{
            width: '100%',
            height: '50vh',
          }}
        >
          <Card css={cardCssStyles}>
            <div
              style={{
                backgroundColor:
                  'var(--abyss-colors-web-semantic-color-surface-container-primary)',
                color:
                  'var(--abyss-colors-web-semantic-color-text-content-primaryAlt)',
                paddingTop: '5px',
                paddingBottom: '5px',
                paddingLeft: '24px',
                paddingRight: '24px',
                borderTopLeftRadius: '3px',
                borderTopRightRadius: '3px',
                fontSize: '18px',
                fontWeight: 'bold',
              }}
            >
              Customer Profile Move
            </div>
            {(resMessage || error) && (
              <Box color="$web.semantic.color.text.content.primary-alt">
                <div>
                  {error?.targetEnvironment && (
                    <strong style={{ color: 'red' }}>
                      {error?.targetEnvironment}
                    </strong>
                  )}
                </div>
                <div>
                  {error?.profilType && (
                    <strong style={{ color: 'red' }}>
                      {error?.profilType}
                    </strong>
                  )}
                </div>

                <Text css={{ color: resMessage?.isSuccess ? 'green' : 'red' }}>
                  <strong>
                    {isEmptyObject(resMessage) ? (
                      ''
                    ) : resMessage?.isSuccess ? (
                      'Your Request has been Sucessfully Submitted'
                    ) : (
                      <ul>
                        {resMessage?.error?.response?.data?.validationErrors.map(
                          (item) => (
                            <li>{item}</li>
                          )
                        )}

                        <li style={{ marginTop: '10px' }}>
                          * Your request cannot be completed at this time ,
                          please connect with EEMS IT Team via
                          (E3IssueseHelpline_DL@ds.uhc.com)
                        </li>
                      </ul>
                    )}
                  </strong>
                </Text>
              </Box>
            )}

            {isLoading ? (
              <>
                <Box
                  align="center"
                  color="$web.semantic.color.text.content.primary-alt"
                >
                  <LoadingSpinner
                    size="xs"
                    color="$web.semantic.color.icon.interactive.rest.tertiary"
                    variant="alt"
                    isLoading={isLoading}
                    ariaLoadingLabel="Loading"
                  />

                  <h6>Loading Please Wait</h6>
                </Box>
              </>
            ) : (
              <>
                <div style={{ padding: '16px' }}>
                  <Layout.Group
                    css={{
                      alignItems: 'start',
                    }}
                    grow
                  >
                    <Table.Container title="">
                      <Table.Row>
                        <Table.Cell>Customer Submission Id</Table.Cell>
                        <Table.Cell>
                          {submitterDetails?.submitterAssignId}
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>Source Environment (from)</Table.Cell>

                        <Table.Cell>{moveConfig?.source?.label}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>Target Environment</Table.Cell>
                        <Table.Cell>
                          {' '}
                          {isSubmittedClicked ? (
                            <>{targetEnvironment}</>
                          ) : (
                            <SelectInput
                              label=""
                              placeholder="Pick one"
                              model={'targetEnvironment'}
                              options={moveConfig?.target}
                            />
                          )}
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>Version</Table.Cell>
                        <Table.Cell>
                          {submitterDetails.versionNumber}
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>Profile Move Type</Table.Cell>
                        <Table.Cell>
                          {!isSubmittedClicked && (
                            <RadioGroup label="" model="profileType">
                              <RadioGroup.Radio
                                label="Profile & Contact"
                                value="MoveProfile"
                              />
                              <RadioGroup.Radio
                                label="Contact Only"
                                value="MoveContact"
                              />
                            </RadioGroup>
                          )}
                          {isSubmittedClicked && (
                            <>
                              {profilType === 'MoveProfile'
                                ? 'Profile & Contact'
                                : 'Contact Only'}
                            </>
                          )}
                        </Table.Cell>
                      </Table.Row>
                    </Table.Container>
                  </Layout.Group>
                </div>
                <Layout.Group
                  alignLayout="center"
                  css={{ marginBottom: '20px' }}
                >
                  {isSubmittedClicked && !resMessage?.isSuccess && (
                    <Button onClick={() => setIsSubmittedClicked(false)}>
                      Try Again
                    </Button>
                  )}
                  <Button
                    onClick={() =>
                      router.navigate(
                        `/profile/${encryptProfileParams(
                          submitterDetails?.versionNumber,
                          submitterDetails?.submitterAssignId,
                          submitterDetails?.destinationSystem
                        )}`
                      )
                    }
                  >
                    {isSubmittedClicked && resMessage?.isSuccess
                      ? 'Go Back'
                      : 'Cancel'}
                  </Button>
                  {isSubmittedClicked &&
                  (resMessage?.isSuccess || !resMessage?.isSuccess) ? null : (
                    <Button onClick={handleSubmit}>Submit</Button>
                  )}
                </Layout.Group>
              </>
            )}
          </Card>
        </Grid.Col>
      </Grid>
    </FormProvider>
  );
};

export default MoveProfile;
